import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  cardContainer: {
    padding: "20px",
    marginBottom: theme.spacing(2),
  },
  topContainer: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
    },
  },
  leftContainer: {
    order: 1,
    width: "60%",
    [theme.breakpoints.down("xs")]: {
      width: "80%",
      flexWrap: "wrap",
    },
  },
  rightContainer: {
    order: 2,
    width: "40%",
    [theme.breakpoints.down("xs")]: {
      order: 3,
      width: "100%",
      justifyContent: "flex-start",
      marginTop: theme.spacing(1),
    },
  },
  deleteContainer: {
    order: 3,
    [theme.breakpoints.down("xs")]: {
      width: "20%",
      order: 2,
      display: "flex",
      alignItems: "center",
    },
  },
  flagButton: {
    color: theme.palette.error.main,
    borderRadius: "24px",
    fontWeight: "bold",
    textTransform: "capitalize",
    marginLeft: theme.spacing(2),
  },
  flagButtonBorder: {
    "&.MuiButton-outlined": {
      borderColor: theme.palette.error.main,
    },
  },
  menuButton: {
    backgroundColor: "#fff",
    letterSpacing: "0px",
    padding: "0px",
    height: "29px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      height: "25px",
    },
  },
  menuInput: {
    paddingRight: "5px",
  },
  deleteIcon: {
    color: theme.palette.error.main,
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      justifyContent: "flex-end",
    },
  },
  mobileLabels: {
    marginTop: "5px",
    fontSize: "12px",
    color: "#9A9A9A",
    textAlign: "center",
  },
}))

export default styles
